import React, { useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CloseIcon from '@mui/icons-material/Close'
import ButtonMui from '@mui/material/Button'
import messages from './ProductControlSwitcher.messages'
import { useIntl } from 'react-intl'
import { animated, useTransition } from 'react-spring'
import { styled } from '@mui/material/styles'

interface IOwnProps {
  initialContent: () => React.ReactNode
  toggleContent: () => React.ReactNode
}

interface ISwitcher {
  onClick: () => void
}

const IconButton = styled(ButtonMui)(() => ({
  minWidth: 'auto',
  padding: '11px 3px',
  marginLeft: 8,
}))

const Switcher: React.FC<ISwitcher> = (props) => {
  const { children, ...rest } = props
  const intl = useIntl()

  return (
    <IconButton
      variant='contained'
      color='secondary'
      disableRipple
      aria-label={intl.formatMessage({ ...messages.switchProductControl })}
      {...rest}
    >
      {children}
    </IconButton>
  )
}

const AnimatedSwitcherContainer = animated(styled('div')({
  display: 'flex',
}))

const ProductControlSwitcher: React.FC<IOwnProps> = (props) => {
  const {
    initialContent,
    toggleContent,
  } = props

  const [shouldSwitchControl, setShouldSwitchControl] = useState(true)
  const transitions = useTransition(shouldSwitchControl, {
    initial: { rotateX: '0deg' },
    from: { rotateX: '90deg' },
    keys: null,
    enter: { rotateX: '0deg' },
    leave: { rotateX: '90deg' },
    exitBeforeEnter: true,
    config: {
      duration: 100,
    },
  })

  const handleClick = () => {
    setShouldSwitchControl(!shouldSwitchControl)
  }

  return transitions((style, item) => item
    ? (
      <AnimatedSwitcherContainer style={style}>
        {initialContent()}

        <Switcher onClick={handleClick}>
          <MoreVertIcon />
        </Switcher>
      </AnimatedSwitcherContainer>
    )
    : (
      <AnimatedSwitcherContainer style={style}>
        {toggleContent()}

        <Switcher onClick={handleClick}>
          <CloseIcon />
        </Switcher>
      </AnimatedSwitcherContainer>
    ))
}

export default ProductControlSwitcher
